<template>
    <div class="rating-stars">
        <v-icon v-for="i in stars" :key="i" :size="size" :color="starColor(i)">
            {{ starIcon(i) }}
        </v-icon>
        <span v-if="showValue" class="rating-value" :style="{ fontSize: `${valueSize}px` }">
            {{ formattedValue }}
        </span>
    </div>
</template>

<script>
export default {
    name: "RatingStars",
    props: {
        value: {
            type: [Number, String],
            default: 0,
        },
        stars: {
            type: [Number, String],
            default: 1,
        },
        size: {
            type: [Number, String],
            default: 14,
        },
        showValue: {
            type: Boolean,
            default: true,
        },
        themeColor: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        rating(vm = this) {
            return Number(vm.value) || 0
        },
        formattedValue(vm = this) {
            return vm.rating.toFixed(1).replace('.0', '')
        },
        valueSize(vm = this) {
            return Math.max(11, Math.round(Number(vm.size) * 0.85))
        },
        activeColor(vm = this) {
            if (!vm.themeColor) return 'star'
            return vm.$vuetify.theme.dark ? 'primary' : 'accent'
        },
    },
    methods: {
        starIcon(index) {
            const vm = this
            if (vm.stars == 1) return vm.rating > 0 ? 'mdi-star' : 'mdi-star-outline'
            if (vm.rating >= index) return 'mdi-star'
            if (vm.rating >= index - 0.5) return 'mdi-star-half-full'
            return 'mdi-star-outline'
        },
        starColor(index) {
            const vm = this
            if (vm.stars == 1) return vm.rating > 0 ? vm.activeColor : 'txtMuted'
            const filled = vm.rating >= index || vm.rating >= index - 0.5
            return filled ? vm.activeColor : 'outline2'
        },
    },
}
</script>

<style scoped>
.rating-stars {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    line-height: 1;
}

.rating-value {
    font-weight: 700;
    color: var(--v-txtSecondary-base);
    margin-left: 2px;
}
</style>
